<template>
  <div id="internal-wallet-withdraw">
    <vs-alert color="danger" icon-pack="feather" icon="icon-alert-triangle" class="mb-4" active="true" v-if="wallet && wallet.internal.name == 'toman' && listCards.length < 1">
      {{$t('You do not have a verified bank account.')}}
    </vs-alert>
    <transition name="zoom-fade">
      <div class="grid grid-cols-12 gap-6" v-if="!wallet">
        <div class="lg:col-span-7 col-span-12">
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="200px" class="mb-4"/>
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="350px" class="mb-4"/>
        </div>
        <div class="lg:col-span-5 col-span-12" v-if="!isSmallerScreen">
          <vue-skeleton-loader  animation="fade" type="rect" rounded width="100%" height="550px" class="mb-4"/>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-6" v-if="wallet">
        <div class="lg:col-span-7 col-span-12">
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12">
              <statistics-card-line
                icon="CreditCardIcon"
                icon-right
                :statistic="wallet.balance.toLocaleString('en-US') +' '+ $t(wallet.internal.name)"
                :statisticTitle="$t('Balance')+' ('+ $t(wallet.internal.symbol) +') '"
                type="area"
                :hideChart="chart.series[0].data.length <=2 ? true : false"
                to-locale-str
                color="danger"
                :chartData="chart.series" />
            </div>

            <vx-card class="col-span-12" collapseAction :title="$t('Withdraw from wallet')">
              <div slot="no-body" class="tabs-container lg:px-6 pt-6 px-1">

                <form autocomplete="off" v-on:submit.prevent="submitFormWithdraw()" class="pb-6">

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <div class="lg:mt-3">{{$t('Amount')}}</div>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full relative">
                      <vs-input class="w-full vazir" icon-pack="feather" :size="!isSmallerScreen?'large':null" icon-no-border icon="icon-hash" v-model="amount"
                                v-validate="'required'" :class="errors.has('amount') && withdrawSubmit ? 'border-danger':'' " name="amount" maxlength="15"/>
                      <span class="label-absolute capitalize">{{$t(wallet.internal.name)}}</span>
                      <vs-slider text-fixed='%' ticks v-model="amountPercent" @click.native="$event.preventDefault()" class="w-11/12 mx-auto"/>

                      <p class="mt-2">
                        {{$t('Your withdrawable balance')}}:
                        <span class="text-warning cursor-pointer border-b border-solid border-l-0 border-r-0 border-t-0" @click="amount=wallet.balance_available.toLocaleString('en-US')">
                          <i class="feather icon-hash"></i>{{wallet.balance_available.toLocaleString('en-US')}}
                        </span>
                      </p>
                      <p class="capitalize">
                        مقدار برداشت روزانه معادل:
                        {{ parseInt(levelUsed.daily_withdrawal_internal).toLocaleString('en-US') }}
                        از
                        {{parseInt(levelInfo.dailyWithdrawalTomans).toLocaleString('en-US')}} {{$t(wallet.internal.name)}}
                      </p>
                    </div>
                  </div>



                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                      <div class="lg:mt-3">{{$t('Bank account to receive')}}</div>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <div class="vx-col w-full">
                        <vs-select class="w-full" name="card" v-validate="'required'" v-model="card" :placeholder="$t('Select bank account')"
                                   :descriptionText="$t('See the list of your approved bank accounts')" :class="errors.has('card') && withdrawSubmit ? 'border-danger':''">
                          <vs-select-item :key="index" :value="item.id" :text="item.card +' ' + item.bank" v-for="(item,index) in listCards" />
                        </vs-select>
                      </div>
                    </div>
                  </div>

                  <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full">
                      <div class="lg:mt-3"></div>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full flex">
                      <vs-button class="mr-3 mb-2" icon-pack="feather" icon="icon-check" :disabled="isLoading"
                                 :id="'button-withdraw'" @click.prevent="submitFormWithdraw">
                        {{$t('Submit request')}}
                      </vs-button>
                      <vs-button color="dark" type="border" class="mb-2 " :to="'/wallets'">بازگشت</vs-button>
                    </div>
                  </div>

                </form>
              </div>
            </vx-card>
          </div>
        </div>

        <vx-card class="lg:col-span-5 col-span-12" collapseAction :title="$t('Tips for withdraw')">

          <div slot="no-body" class="tabs-container lg:px-6 pt-6 px-1">
            <p class="mb-3">
              می توانید هر کدام از حساب های تایید شده خود را برای برداشت انتخاب کنید.
            </p>
            <p class="mb-3">
              مبلغ 1,000 تا 5,000 تومان کارمزد  پایا در هنگام واریز به حساب مقصد کسر خواهد شد.
            </p>
            <p class="mb-3">
              حداقل مبلغ برداشت 2,000 تومان می باشد.
            </p>
            <p class="mb-3">
              ثبت درخواست تسویه به مقصد بانک آینده در لحظه پردازش خواهد شد و به حساب مقصد واریز خواهد شد.
            </p>
          </div>
        </vx-card>
      </div>

    </transition>
    <History :coin="true" class="mt-base" ref="History"/>
  </div>

</template>
<i18n locale="fa">
{
  "Withdraw from wallet":"برداشت از کیف پول"
  ,"Tips for withdraw":"نکات جهت برداشت"
  ,"See the list of your approved bank accounts": "لیست حساب بانکی های تایید شده خودتان را میبینید"
  ,"Select bank account": "انتخاب حساب بانکی"
  ,"Bank account to receive": "حساب بانکی جهت دریافت"
  ,"Your withdrawable balance":"موجودی قابل برداشت شما"
  ,"You do not have a verified bank account.":"حساب بانکی تایید شده ای ندارید."
  ,"Withdrawal confirmation code":"کد تایید برداشت"
}
</i18n>
<script>
  import axios from '../../../../axios'
  import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
  import History from "../../../tools/history/internal/Internal";
  import VueSkeletonLoader from 'skeleton-loader-vue';

  export default {
    data () {
      return {
        wallet: null,
        listCards: null,
        levelUsed: null,
        levelInfo: null,
        isLoading:false,
        withdrawSubmit:false,
        amount:'',
        amountPercent:0,
        card:'',
        gateway:null,
        chart: {
          series: [{
            name: this.$t('Balance'),
            data: []
          }]
        },
        codeOtp: null,
      }
    },
    computed: {
    },
    components: {
      StatisticsCardLine,History,
      VueSkeletonLoader
    },
    watch:{
      amount(value){
        this.amount = this.amountLocalFloat(value,this.wallet.internal.percent)
      },
      amountPercent(value){
        this.amount = ((this.wallet.balance_available / 100) * value).toLocaleString('en-US')
        this.amount = this.amount == 0 ? '' : this.amount;
      }
    },
    methods:{
      refreshData(){
        this.getWallet();
        this.$refs.History.getList();
      },
      getWallet(){
        const self = this
        axios.post('/wallets/internal?withdraw=true').then(function (response) {
          self.wallet = response.data.wallet
          self.levelUsed = response.data.level_used
          self.levelInfo = response.data.level_info
          self.listCards = response.data.list_cards
          self.card = response.data.list_cards ? response.data.list_cards[0].id : null;
          self.chart.series[0].data = response.data.chart
        }).catch(function (error) { console.log(error); })
      },
      submitFormWithdraw(){
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.loading({
              container: '#button-withdraw',
              scale: 0.65
            })
            const self = this
            axios.post('/wallets/internal/withdraw',
              {
                amount: this.amount.replace(/[^\d.-]/g, ''),
                card:this.card,
                codeOtp:this.codeOtp,
              })
              .then(function (response) {
                if (response.data.status == true) {
                  self.$swal({
                    icon: 'success',
                    title: self.$t('Success'),
                    text: response.data.msg
                  })
                  self.amount = '';
                  self.amountPercent = 0;
                  self.getWallet();
                }else if(response.data.otp == true) {
                  self.otp(response);
                }else {
                  self.$vs.notify({title: self.$t('Error'),text: response.data.msg ,iconPack: 'feather',icon: 'icon-alert-circle',color: 'danger'})
                }
                self.$vs.loading.close('#button-withdraw > .con-vs-loading');
                self.isLoading = false;
              }).catch(function (error) { self.$vs.loading.close('#bbutton-withdraw > .con-vs-loading'); self.isLoading = false; })
          }else
            this.withdrawSubmit = true
        })
      },
      otp(response) {
        this.$swal({
          icon: 'question',
          title: this.$t('Withdrawal confirmation code'),
          input: 'text',
          inputLabel: (response.data.msgOtp ? response.data.msgOtp : response.data.msg),
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return this.$t('You must enter the code!')
            }
          },
          preConfirm: (value) => {
            this.codeOtp = value;
            this.submitFormWithdraw();
          },
        })
      }
    },

    mounted () {

    },
    created () {
      this.getWallet();
    }
  }
</script>

<style lang="scss">
  #internal-wallet-withdraw{
    .label-absolute{
      position: absolute;
      right: 22px;
      top: 18px;
      padding-left: 5px;
    }

    @media only screen and (max-width: 768px) {
      .label-absolute{
        top: 10px;
      }
    }
  }
</style>
